module.exports = __webpack_public_path__ + "static/img/support_banner.9950c249.png";